import { SPATEM } from '_lib/api';
import { RootState,useAppDispatch  } from '_store';
import applicationReducer from '_store/application/reducer';
import { DialogType } from '_store/application/types';
import { getSpatemActivityStatus } from '_store/spatem/utils';
import { useLocalization } from '@fluent/react';
import { Box, Card, CardContent } from '@material-ui/core';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { SpatemStatus } from '../../../icons';
import { Accordion } from "../../../items/Accordion";
import { toLatLng } from '../../../routes/MapView/utils';
import styles from '../../Device/Card/styles';
import SpatemCardDetails from './Details';

export interface CardSpatemListItemProps {
  text: string;
  spatem: SPATEM;
  asCard: boolean;
}

const CardSpatemListItem: FC<CardSpatemListItemProps> = ({ text, spatem, asCard }) => {
  const { l10n } = useLocalization();
  const classes = styles();
  const dispatch = useAppDispatch();
  const mapRef = useSelector((state: RootState) => state.application.mapRef);

  // Force re-render every second to update activity status based on time
  const [, setTick] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Calculate activity status - recalculates on every render to handle time-based updates
  const activityStatus = useMemo(() => getSpatemActivityStatus(spatem), [spatem]);

  const onAccordionExpanded = () => {
    if (spatem?.location?.coordinates) {
      const markerPosition = toLatLng(spatem.location.coordinates);
      mapRef.flyTo(markerPosition, 15, { animate: true, duration: 1 });

      setTimeout(() => {
        dispatch(
          applicationReducer.actions.infoSelected({
            type: DialogType.SPATEM_LIST,
            id: spatem.id,
          }),
        );
      }, 1000);
    }
  };

  const onAccordionClose = () => {
    dispatch(
      applicationReducer.actions.infoSelected({
        type: DialogType.SPATEM_LIST,
        id: '4',
      }),
    );
  };

  const details = <SpatemCardDetails spatem={spatem} />;

  const body = (
    <CardContent className={classes.cardContent}>
      <Box className={classes.headerBox}>
        <div className={classes.headerIconAndTitle}>
          <SpatemStatus status={activityStatus} />
          <span>{text}</span>
        </div>
      </Box>

      {asCard ? (
        <>
          <Accordion
            title={l10n.getString('view-details')}
            onExpanded={onAccordionExpanded}
            onClose={onAccordionClose}
          >
            {details}
          </Accordion>
        </>
      ) : (
        details
      )}
    </CardContent>
  );

  if (asCard) {
    return <Card className={classes.root}>{body}</Card>;
  }
  return body;
};

export default React.memo(CardSpatemListItem);

